// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @bitwarden/platform/no-enums
export enum IdpProvider {
  Azure = 0,
  OktaAuthServer = 1,
  OktaNoAuthServer = 2,
  Google = 3,
  PingOne = 4,
  OneLogin = 5,
}
